import React, {useEffect} from 'react';
import {classes, style} from './doppe-action-widget-cta-buttons-list.st.css';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {
    doppeActionCtaButtonTypeGetGoalType,
    DoppeActionSettingsCTAButtonSettings
} from '../../client-server-common/types/doppe-action-cta-button';
import {DoppeActionGoalType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {DoppeActionCtaButtonsSettings} from '../../client-server-common/types/doppe-action-cta-buttons-settings';
import {flexColumn, useDynamicRef, useWasVisibleInViewport} from '@wix/devzai-utils-react';
import {
    DoppeActionTypeWidgetInnerLinkTypeCtaButton
} from '../doppe-action-type-widget-inner-link-type-cta-button/doppe-action-type-widget-inner-link-type-cta-button';
import {BymoPageViewerMode, useBymoPageViewerContext} from '../bymo-page-viewer-context/bymo-page-viewer-context';

export const DoppeActionWidgetCtaButtonsList = React.memo(function DoppeActionWidgetCtaButtonsList(props: DoppeActionWidgetCtaButtonsList.Props) {
    const {
        ctaButtonsSettings,
        sourceURL,
        ctaCallback,
        onClick,
        listItemId,
        actionContext,

        ...htmlAttributes
    } = props;

    const viewerContext = useBymoPageViewerContext();

    const rootRef = useDynamicRef<HTMLDivElement>();
    const wasVisible = useWasVisibleInViewport(rootRef);

    const visibleButtons = ctaButtonsSettings.ctaButtons.filter(ctaButton => ctaButton.isVisible);

    useEffect(() => {
        if (wasVisible && viewerContext.mode === BymoPageViewerMode.Live) {
            visibleButtons.forEach((ctaButton, index) => {
                const goalType = doppeActionCtaButtonTypeGetGoalType(ctaButton.settings.type);

                actionContext.reportCtaButtonViewed({
                    innerItemId: listItemId,
                    buttonId: ctaButton.id,
                    buttonIndex: index,
                    goalType:goalType
                });
            })
        }
    }, [wasVisible]);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {}, flexColumn())}
            ref={rootRef}
        >
            {
                visibleButtons.map((ctaButton, index) => {
                    return (
                        <DoppeActionTypeWidgetInnerLinkTypeCtaButton
                            key={index}
                            actionContext={actionContext}
                            ctaButton={{
                                settings: ctaButton.settings,
                                showButton: ctaButton.isVisible,
                                text: ctaButton.text
                            }}
                            sourceURL={sourceURL}
                            ctaCallback={ctaCallback}
                            onClick={goalType => {
                                onClick(goalType);

                                actionContext.reportCtaButtonClicked({
                                    innerItemId: listItemId,
                                    buttonId:  ctaButton.id,
                                    buttonIndex: index,
                                    goalType: goalType,
                                });
                            }}
                            listItemId={listItemId}
                        />
                    );
                })
            }
        </div>
    );
});

export namespace DoppeActionWidgetCtaButtonsList {

    export interface Props {
        actionContext: IDoppeViewerActionContext<any>;
        ctaButtonsSettings: DoppeActionCtaButtonsSettings;
        sourceURL?: string;
        ctaCallback?: (settings: DoppeActionSettingsCTAButtonSettings) => void;
        listItemId?: string;
        onClick: (goalType: DoppeActionGoalType) => void;
    }

}
